export default __webpack_public_path__ + "static/media/background.a0394ab9.svg";